import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Notice
 *
 * Notice을 설명하세요.
 */
export const Notice = types
  .model('Notice')
  .props({
    no: types.optional(types.number, 0),
    noticeSid: types.optional(types.number, 0),
    prNotiCtgyCd: types.maybeNull(CodeModel),
    title: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    filePath: types.maybeNull(types.optional(types.array(types.string), [])),
    useYn: types.optional(types.boolean, false),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .volatile(() => ({
    files: types.maybeNull(types.array(types.frozen())),
  }))
  .actions(withSetPropAction);

type TNotice = Instance<typeof Notice>;
type TNoticeSnapshot = SnapshotOut<typeof Notice>;

export interface INotice extends TNotice {}
export type TNoticeKeys = keyof TNoticeSnapshot & string;
export interface INoticeSnapshot extends TNoticeSnapshot {}
export const createNotice = () => types.optional(Notice, {} as TNotice);
